import React from 'react';
import { Button } from 'antd';
import { MinusOutlined, PlusOutlined } from '@ant-design/icons';
import { ShoppingCartQuantityControlsProps } from '../interfaces';

const ShoppingCartQuantityControls: React.FC<ShoppingCartQuantityControlsProps> = ({
  disabled,
  incrementDisabled,
  productTitle,
  quantity,
  onDecrement,
  onIncrement,
}) => (
  <div className="quantity-controls">
    <Button
      icon={<MinusOutlined />}
      disabled={disabled}
      onClick={onDecrement}
      aria-label={`Decrease quantity of ${productTitle}`}
    />
    <span className="quantity-value">{quantity}</span>
    <Button
      icon={<PlusOutlined />}
      disabled={incrementDisabled}
      onClick={onIncrement}
      aria-label={`Increase quantity of ${productTitle}`}
    />
  </div>
);

export default React.memo(ShoppingCartQuantityControls);
